import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { InputTextarea } from 'primereact/inputtextarea';

import LabelName from 'components/UI/LabelName/LabelName';
import { RequiredValidation } from 'components/UI/RequiredValidation/RequiredValidation';
import SubText from '../FormComponenets/SubText';

export default function LongText({
  handleSettingsClick,
  item,
  index,
  isFormBuilder,
  relationFieldName,
  isRelation = false,
  isFromPreview = false,
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { subtext, required, label = 'Short Text' } = item || {};
  const name = isRelation ? relationFieldName : `form_data.${index}.value`;

  const _label = item?.res_type === 'custom-field' ? item?.name : label;

  return (
    <div className="w-100">
      <LabelName>
        {_label}
        {required && <span className="danger-text"> *</span>}
      </LabelName>
      <div className="d-flex align-items-center flex-wrap">
        <Controller
          name={name}
          control={control}
          rules={isFormBuilder ? {} : { required: required ? 'Required Field' : false }}
          render={({ field, fieldState }) => (
            <InputTextarea
              placeholder="Type in"
              id={field.name}
              rows={4}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              value={field.value || ''}
              className={classNames({ 'p-invalid': fieldState.invalid, 'w-100 input-shadow': true })}
              style={{ pointerEvents: isFormBuilder ? 'none' : 'auto' }}
              ref={isFormBuilder ? null : field.ref}
              readOnly={isFromPreview}
            />
          )}
        />
        <SubText {...{ subtext, handleSettingsClick, item, isFormBuilder }} />
      </div>
      <RequiredValidation field={name} errors={errors} />
    </div>
  );
}
